"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header3 = exports.Header1 = exports.Div = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Div = function (_a) {
    var _b = _a.visible, visible = _b === void 0 ? true : _b, children = _a.children, props = __rest(_a, ["visible", "children"]);
    return visible ? react_1.default.createElement("div", __assign({}, props), children) : null;
};
exports.Div = Div;
exports.Header1 = styled_components_1.default.h1(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 24px;\n  line-height: 32px;\n  font-weight: 500;\n  margin: 0;\n"], ["\n  color: ", ";\n  font-size: 24px;\n  line-height: 32px;\n  font-weight: 500;\n  margin: 0;\n"])), function (p) { return p.theme.colors.black; });
exports.Header3 = styled_components_1.default.h3(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 24px;\n  line-height: 32px;\n  font-weight: 500;\n  margin: 0;\n"], ["\n  color: ", ";\n  font-size: 24px;\n  line-height: 32px;\n  font-weight: 500;\n  margin: 0;\n"])), function (p) { return p.theme.colors.black; });
var templateObject_1, templateObject_2;
